import axiosMiddleware from 'middleware/api/axios'
import actionType from 'middleware/api/actionType'
import * as localEdits from 'middleware/api/localEdits'
import queueOnly from 'middleware/api/queueOnly'
import previous from 'middleware/api/previous'


export default () => [
  actionType,
  localEdits.preRequest,
  queueOnly,
  axiosMiddleware,
  localEdits.postRequest,
  previous,
]
